/*eslint-disable*/
import React, { useState } from 'react'
import { Modal } from 'semantic-ui-react'
import AddModal from '../../components/commonComponent/addModal'
import FormikAddTyrePosition from '../../components/mastersComponent/tyrePosition/addTyrePosition'
import TyrePositionTable from '../../components/mastersComponent/tyrePosition/tyrePositionTable'


function TyrePosition() {
    const [modalOpen, setmodalOpen] = useState(false)
    const [searchValue, setsearchValue] = useState('')
    let handleSearch = (e, data) => {
        setsearchValue(data.value)
    }
    return (
        <React.Fragment>
            <div className="ag-theme-material agOver">
                <TyrePositionTable handleSearch={handleSearch} newPopup={() => setmodalOpen(true)} searchValue={searchValue} />
            </div>
            <AddModal className="p-overflow-visible" onClose={() => setmodalOpen(false)} open={modalOpen} size="mini">
                <Modal.Header>New Tyre Position</Modal.Header>
                <FormikAddTyrePosition handleClose={() => setmodalOpen(false)} />
            </AddModal>
        </React.Fragment>
    )
}

export default TyrePosition
